import useSearchParamOrDefaultProps from '../hooks/useSearchParamOrDefaultProps.js';
import ArticleTitleUnderlineVariant from './ArticleTitleUnderlineVariant.js';
import styles from './Banner.module.css';

const Banner = () => {
  const {
    bannerTitle,
    bannerTitleVariant,
    bannerSubtitle,
    bannerLeftImageSrc,
    bannerRightImageSrc,
    bannerBackgroundColor: backgroundColor,
  } = useSearchParamOrDefaultProps();

  const hasBackgroundImageSrc = bannerLeftImageSrc && bannerRightImageSrc;

  const backgroundImgStyles = hasBackgroundImageSrc
    ? {
        backgroundImage: `url(${bannerLeftImageSrc}), url(${bannerRightImageSrc})`,
        backgroundColor,
      }
    : {
        backgroundColor,
      };

  return (
    <div className={styles.bannerWrapper} style={backgroundImgStyles}>
      <div className={styles.bannerTitle}>
        <ArticleTitleUnderlineVariant
          title={bannerTitle}
          variant={bannerTitleVariant}
        />
      </div>
      <div className={styles.bannerSubtitle}>{bannerSubtitle}</div>
    </div>
  );
};

Banner.displayName = 'Banner';

export default Banner;
